/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetInvoiceGroupTypeQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetInvoiceGroupTypeQuery = {
  __typename?: 'Query',
  invoiceGroupType: {
    __typename?: 'InvoiceGroupType',
    id: number,
    name: string,
    externalId?: string | null,
    declarationAutoCreationCondition?: Types.DeclarationAutoCreationCondition | null,
    charterTypes: Array<Types.CharterType>
  }
};

export type GetInvoiceGroupTypesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.InvoiceGroupTypeSearch>;
}>;


export type GetInvoiceGroupTypesQuery = {
  __typename?: 'Query',
  invoiceGroupTypes: Array<{
    __typename?: 'InvoiceGroupType',
    id: number,
    name: string,
    externalId?: string | null,
    declarationAutoCreationCondition?: Types.DeclarationAutoCreationCondition | null,
    sequenceNumber?: number | null,
    charterTypes: Array<Types.CharterType>
  }>
};

export type SelectInvoiceGroupTypesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.InvoiceGroupTypeSearch>;
}>;


export type SelectInvoiceGroupTypesQuery = {
  __typename?: 'Query',
  invoiceGroupTypes: Array<{
    __typename?: 'InvoiceGroupType',
    id: number,
    name: string,
    charterTypes: Array<Types.CharterType>
  }>
};

export type GetInvoiceGroupTypeSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetInvoiceGroupTypeSettingsQuery = {
  __typename?: 'Query',
  invoiceGroupTypeSettings?: {
    __typename?: 'InvoiceGroupTypeSettings',
    advancePayment?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null,
    advancePaymentCorrection?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null
  } | null
};


export const GetInvoiceGroupTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"declarationAutoCreationCondition"}},{"kind":"Field","name":{"kind":"Name","value":"charterTypes"}}]}}]}}]} as unknown as DocumentNode<GetInvoiceGroupTypeQuery, GetInvoiceGroupTypeQueryVariables>;
export const GetInvoiceGroupTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceGroupTypeSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"declarationAutoCreationCondition"}},{"kind":"Field","name":{"kind":"Name","value":"sequenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charterTypes"}}]}}]}}]} as unknown as DocumentNode<GetInvoiceGroupTypesQuery, GetInvoiceGroupTypesQueryVariables>;
export const SelectInvoiceGroupTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"selectInvoiceGroupTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceGroupTypeSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charterTypes"}}]}}]}}]} as unknown as DocumentNode<SelectInvoiceGroupTypesQuery, SelectInvoiceGroupTypesQueryVariables>;
export const GetInvoiceGroupTypeSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInvoiceGroupTypeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupTypeSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advancePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advancePaymentCorrection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvoiceGroupTypeSettingsQuery, GetInvoiceGroupTypeSettingsQueryVariables>;